var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhatsappIconWhite = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-whatsapp_icon_white"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "whatsapp_icon_white",
  clipPath: "url(#clip-whatsapp_icon_white)"
}, /*#__PURE__*/React.createElement("g", {
  id: "whatsapp",
  transform: "translate(0.436 0.279)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_41249",
  "data-name": "Path 41249",
  d: "M0,23.283l.858-3.138c.24-.88.485-1.758.715-2.64a.54.54,0,0,0-.044-.359A11.528,11.528,0,0,1,5.177,2a10.891,10.891,0,0,1,7.9-1.875,11.2,11.2,0,0,1,9.553,7.991A11.541,11.541,0,0,1,13.09,23a11.322,11.322,0,0,1-6.718-1.178.708.708,0,0,0-.549-.062Q3.03,22.509.231,23.238c-.061.016-.125.024-.231.045Zm2.769-2.735c.075-.016.113-.023.15-.033,1.046-.274,2.093-.543,3.136-.826a.754.754,0,0,1,.633.082,9.306,9.306,0,0,0,8.738.578A9.587,9.587,0,0,0,12.1,1.971,9.381,9.381,0,0,0,5.6,4.113,9.354,9.354,0,0,0,2.059,11.02,9.333,9.333,0,0,0,3.6,16.794a.52.52,0,0,1,.071.47c-.3,1.079-.595,2.162-.9,3.283Z",
  transform: "translate(0 0)",
  fill: "#ffffff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_41250",
  "data-name": "Path 41250",
  d: "M160.441,170.524c.529-.138.761.177.934.626.258.67.54,1.33.825,1.99a.588.588,0,0,1-.053.637c-.232.31-.457.627-.7.927a.444.444,0,0,0-.039.573,7.91,7.91,0,0,0,3.965,3.411.451.451,0,0,0,.581-.139c.288-.359.588-.709.864-1.077a.438.438,0,0,1,.584-.188c.825.386,1.648.778,2.464,1.183a.391.391,0,0,1,.169.289,2.188,2.188,0,0,1-.992,2.073,3.471,3.471,0,0,1-2.97.379,11.524,11.524,0,0,1-6.224-4.491,7.4,7.4,0,0,1-1.374-2.512,3.286,3.286,0,0,1,.671-3.131,1.286,1.286,0,0,1,1.3-.548Z",
  transform: "translate(-152.567 -164.277)",
  fill: "#ffffff"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhatsappIconWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/whatsapp_icon_white.d50e4bfdd57e2c928c72bd8c08737be6.svg";